module.exports = __webpack_public_path__ + "img/track_safe.dd589862.svg";